import {
  classifyInspectorInteraction,
  INSPECTOR_PARTICIPANTS,
  type InspectorParticipantId,
} from './sequence/classifyParticipant';

export type EventOriginId = InspectorParticipantId | 'timer';

export interface EventOrigin {
  /** Long-form lane name shared with the sequence diagram. */
  fullLabel: string;
  id: EventOriginId;
  label: string;
}

const SHORT_LABELS: Record<EventOriginId, string> = {
  avatar: 'Avatar',
  backend: 'Backend',
  browser: 'Browser',
  machine: 'Machine',
  timer: 'Timer',
  ui: 'User',
};

const FULL_LABELS = new Map(INSPECTOR_PARTICIPANTS.map(({ id, label }) => [id, label]));

export const EVENT_ORIGIN_BADGE_STYLES: Record<EventOriginId, string> = {
  avatar: 'border-emerald-300 bg-emerald-50 text-emerald-700',
  backend: 'border-teal-300 bg-teal-50 text-teal-700',
  browser: 'border-amber-300 bg-amber-50 text-amber-700',
  machine: 'border-slate-300 bg-slate-100 text-slate-600',
  timer: 'border-slate-300 bg-slate-100 text-slate-600',
  ui: 'border-violet-300 bg-violet-50 text-violet-700',
};

export const EVENT_ORIGIN_DOT_COLORS: Record<EventOriginId, string> = {
  avatar: '#059669',
  backend: '#0d9488',
  browser: '#d97706',
  machine: '#64748b',
  timer: '#64748b',
  ui: '#7c3aed',
};

export const EVENT_ORIGIN_ORDER: EventOriginId[] = [
  'ui',
  'browser',
  'backend',
  'avatar',
  'timer',
  'machine',
];

export const getEventOrigin = (eventType: string, isTimer?: boolean): EventOrigin => {
  const timer = isTimer ?? eventType.startsWith('xstate.after.');
  const id: EventOriginId = timer ? 'timer' : classifyInspectorInteraction(eventType).source;

  return {
    fullLabel: id === 'timer' ? 'Machine timer' : (FULL_LABELS.get(id) ?? SHORT_LABELS[id]),
    id,
    label: SHORT_LABELS[id],
  };
};
